class DrawerLookbook extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('#LookbookDrawer-Overlay').forEach(overlay => overlay.addEventListener('click', this.close.bind(this)));
    this.setLookbookIconAccessibility();
  }

  setLookbookIconAccessibility() {
    const lookbookDrawerOpen1 = this.querySelectorAll('[js-lookbook-drawer-open-1]');
    const lookbookDrawerOpen2 = this.querySelectorAll('[js-lookbook-drawer-open-2]');
    const lookbookDrawerClose1 = this.querySelector('[js-lookbook-drawer-close-1]');
    const lookbookDrawerClose2 = this.querySelector('[js-lookbook-drawer-close-2]');
    if (!lookbookDrawerOpen1.length && !lookbookDrawerOpen2.length) return;

    if (lookbookDrawerOpen1.length > 0) {
      lookbookDrawerOpen1.forEach(open => {
        open.setAttribute('role', 'button');
        open.setAttribute('aria-haspopup', 'dialog');
        open.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(open);
        });
      });
      lookbookDrawerClose1.addEventListener('click', (event) => {
        event.preventDefault();
        this.close();
      });
    }

    if (lookbookDrawerOpen2.length > 0) {
      lookbookDrawerOpen2.forEach(open => {
        open.setAttribute('role', 'button');
        open.setAttribute('aria-haspopup', 'dialog');
        open.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(open);
        });
      });
      lookbookDrawerClose2.addEventListener('click', (event) => {
        event.preventDefault();
        this.close();
      });
    }
  }

  open(triggeredBy) {
    if (!triggeredBy) return;

    this.lookbookDrawer = this.querySelector(`#${triggeredBy.getAttribute('aria-controls')}`);
    this.setActiveElement(this.lookbookDrawer);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.lookbookDrawer.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('LookbookDrawerInner');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.lookbookDrawer.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }
  
  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('drawer-lookbook', DrawerLookbook);
